import {isRelativeUrl, parseUrl, toRelativeUrl} from "@khan/urls";

/**
 * Given a target URL (or path) and a collection of URL query
 * parameters, copies any query parameters related to the Khanmigo for
 * Teachers referral program over to the target URL.
 *
 * Useful for ensuring referral-related query params. survive redirects.
 *
 * @param destinationURL a target URL or path onto which referral
 *                       params. should be appended
 * @param originQueryParams a collection of query params. to serve as
 *                          a source from which to copy referral-related
 *                          parametes
 * @returns the destinationURL with any referrals-related params. from
 *          originQueryParams appended to its query string
 */
export default function preserveReferralParams(
    destinationURL: string,
    originQueryParams: URLSearchParams,
): string {
    let referralCode;

    for (const [key, value] of originQueryParams.entries()) {
        if (key.toLowerCase() === "referralcode") {
            referralCode = value;
            break;
        }
    }

    if (!referralCode) {
        return destinationURL;
    }

    const destURLObj = parseUrl(destinationURL);
    const destURLParams = destURLObj.searchParams;

    destURLParams.set("referralCode", referralCode);
    destURLObj.search = destURLParams.toString();

    const modifiedDestURL = destURLObj.toString();

    return isRelativeUrl(destinationURL)
        ? toRelativeUrl(modifiedDestURL)
        : modifiedDestURL;
}
